import { FieldValidator } from 'formik';

export const password: FieldValidator = (value: any) => {
  return /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/g.test(value) ? undefined : 'error.password'
}